import React, { type ReactNode } from 'react';

import { graphql, useFragment } from 'react-relay';

import { token } from '@atlaskit/tokens';

import { AtlasStatusLozenge } from '../../../../../../../common/ui/atlas-status-lozenge';
import { RestrictedIcon } from '../../../../../../../common/ui/restricted-icon';
import { SearchMetadata } from '../../../../../../../common/ui/search-metadata';

import type { projectTitleMetadata_AtlassianSearchPage$key } from './__generated__/projectTitleMetadata_AtlassianSearchPage.graphql';

interface ProjectTitleMetadataProps {
	metadata: projectTitleMetadata_AtlassianSearchPage$key;
}

export const ProjectTitleMetadata = ({
	metadata,
}: ProjectTitleMetadataProps): React.JSX.Element => {
	const data = useFragment(
		graphql`
			fragment projectTitleMetadata_AtlassianSearchPage on SearchResultAtlasProject {
				project {
					isPrivate
					dueDate {
						label
					}
					state {
						label
						value
					}
				}
			}
		`,
		metadata,
	);

	let statusLozenge: ReactNode | null = null;
	if (data.project?.state?.label && data.project?.state?.value) {
		statusLozenge = (
			<AtlasStatusLozenge
				statusValue={data.project.state.value}
				statusLabel={data.project.state.label}
				statusScore={null}
				date={data.project.dueDate?.label}
			/>
		);
	}

	const titleMetadataParts: [string, ReactNode][] = [
		[
			'is-private-project',
			data.project?.isPrivate && (
				<RestrictedIcon permissionLevel="restricted" iconColour={token('color.icon.accent.red')} />
			),
		],
		['status', statusLozenge],
	];

	return <SearchMetadata parts={titleMetadataParts} displaySpacer={false} />;
};
